// extracted by mini-css-extract-plugin
export default {"hasProblem":"HasProblems_hasProblem__b-S-3","label":"HasProblems_label__RTVEW","fields":"HasProblems_fields__rcVL8"};